import { useAppSettings } from '@/lib/appSettings';
import { josa } from '@innermate/shared';
import { Sparkles } from 'lucide-react';

interface Props {
  userName: string;
}

function greeting(hour: number, name: string): string {
  if (hour >= 5 && hour < 12) return `${name}님, 좋은 아침이에요`;
  if (hour >= 12 && hour < 18) return `${name}님, 오늘 어떤 일이 있나요?`;
  if (hour >= 18 && hour < 23) return `${name}님, 좋은 저녁이에요`;
  return `${name}님, 깊은 밤이네요`;
}

export function GreetingHero({ userName }: Props) {
  const hour = new Date().getHours();
  const text = greeting(hour, userName);
  const { data: settings } = useAppSettings();
  const personaName = settings?.personaName?.trim() ?? '';
  return (
    <div className="text-center">
      <div className="inline-grid place-items-center size-12 rounded-2xl bg-accent/15 text-accent mb-5">
        <Sparkles className="size-6" />
      </div>
      {personaName ? (
        <p className="mb-2 text-sm text-foreground-muted">
          {personaName}
          {josa(personaName, '이/가')} 도와드립니다
        </p>
      ) : null}
      <h1 className="text-3xl font-semibold tracking-tight">{text}</h1>
    </div>
  );
}
